module.exports = __webpack_public_path__ + "img/excesoVelocidad.10884f04.svg";